import React from 'react';
import { Box, Button, ButtonBase, Divider, Link, Typography } from '@mui/material';
import { DoctorsDrugsItem } from './doctors-drugs-item';
import { Plus, Stethoscope } from '@phosphor-icons/react';
import { DoctorAddressesPopup } from './doctor-addresses-popup';
import { useDoctorSelection, withDoctorSelectionModal } from '../lib/with-doctor-selection-modal';


const Tab = (props: {hideNoDoctorsMessage?: boolean}) => {
  const {doctors, handleAddClick, handleEditClick, handleDeleteClick} = useDoctorSelection()

  return (<>
    {!doctors.length && <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', pt: '109px'}}>
      {!props.hideNoDoctorsMessage && <>
        <Typography variant={'body2'}><b>No doctors added</b></Typography>
        <Typography variant={'body2'} color={'text.secondary'} sx={{maxWidth: 500, textAlign: 'center', mb: 3, mt: .5}}>
          The pricing of the plans may vary based on the Doctors and Drugs you introduce. <Link target={'_blank'} href={'https://coverright.com/medicare-enrollment/best-way-to-know-medications-and-caregivers-covered-on-medicare/'}>Learn more</Link>.
        </Typography>
      </>}

      <Button data-test={'add-your-doctors-button-z1'} className={'doctor-btn'} variant={'contained'} size={'large'} onClick={handleAddClick}>
        Add your doctors
      </Button>
    </Box>}


    {!!doctors.length && <Box sx={{border: '1px solid #0000001f', borderRadius: '8px'}}>
      {doctors.map(d => <>
        <DoctorsDrugsItem title={d.name}
                          subtitle={d.addresses[0]?.specialty}
                          icon={<Stethoscope size={24} color={'#216069'} />}
                          content={<Box flex={1}>
                            <Typography>{d.addresses[0]?.addressLine1}, {d.addresses[0]?.addressLine2}</Typography>
                            <DoctorAddressesPopup doctor={d} />
                          </Box>}
                          onEditClick={() => handleEditClick(d)}
                          onDeleteClick={() => handleDeleteClick(d)}
                          key={d.npi} />
        <Divider />
      </>)}

      <ButtonBase data-test={'add-another-doctor-button-z1'} sx={{height: 80, pl: '26px', width: 1, justifyContent: 'flex-start', gap: 3}}
                  onClick={handleAddClick}>
        <Plus size={24} color={'#1C434F'} weight={'bold'} />
        <Typography color={'text.secondary'}>Add another doctor</Typography>
      </ButtonBase>

    </Box>}
  </>);
};

const DoctorsTab = withDoctorSelectionModal(Tab);

export { DoctorsTab };
